import Axios from "axios";

/**
 * A deliberately separate axios instance for the emailed-payment-link pages.
 *
 * The shared `redux/api/apiClient` cannot be used here, for three reasons:
 *
 *   1. It attaches `x-auth-token` from localStorage. Nobody is logged in on this
 *      page, and a stale token left over from an unrelated portal session should
 *      play no part in a payment.
 *   2. Its response interceptor dispatches LOGOUT on status 420. There is no
 *      session to end, and a redirect mid-payment would be alarming.
 *   3. Its response interceptor fires a red `Notify()` toast for any response
 *      carrying a `message`. A declined card is a normal, expected outcome that
 *      this page renders as a first-class state with the retry affordance right
 *      there — not something to flash as a generic error and discard.
 *
 * Same `REACT_APP_API_BASE_URL` as the portal, so there is nothing extra to
 * configure at deploy time.
 */
const publicApi = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  // Card authorisation round-trips through NMI. The portal allows 300s; a
  // tenant staring at a phone will not, and an ambiguous timeout on a payment is
  // the worst outcome, so this is tight enough to fail clearly.
  timeout: 45000,
});

export default publicApi;
